import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DEFAULT_PIPELINE, type StageDef } from "@ow/shared";

/** Stage picker bound to a specific role's ladder. Falls back to the default ladder when no
 *  pipeline is supplied (e.g. multi-role admin surfaces without a single role context). */
export function StageSelect({
  value,
  onChange,
  stages = DEFAULT_PIPELINE,
  className = "w-[180px]",
}: {
  value: string;
  onChange: (key: string) => void;
  stages?: StageDef[];
  /** Override the trigger width — table cells pass `h-9 w-full` so the select fills its column. */
  className?: string;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {stages.map((s) => (
          <SelectItem key={s.key} value={s.key}>
            {s.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
